import { createRouter, createWebHistory } from "vue-router";
import HelpView from "../views/HelpView.vue";
import Login from '../components/Login.vue'
import Search from "search-observe-app/views/Search.vue";
import HomeView from "../views/HomeView.vue";

let appStore = null;

export function setStore(store) {
  appStore = store;
}
const router = createRouter({
  base: process.env.BASE_URL,
  history: createWebHistory(),
  routes: [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/help",
    name: "help",
    component: HelpView,
  },
  {
    path: "/login/",
    name: "login",
    component: Login,
  },
  {
    path: "/search",
    name: "search",
    component: Search,
  },
]
})


router.beforeEach(async (to, from, next) => {
  console.log(from);
  if (
    // make sure the user is authenticated
    (appStore.getters['shared/dbName'] === null ||
    appStore.getters['shared/isLoggedIn'] === false) &&
    to.name == "search"  &&
    from.name == null
  ) {
    console.log("sending you home");
    // redirect the user to the login page
    next("/");
  } else if (
    // make sure the user is authenticated
    (appStore.getters['shared/dbName'] === null ||
    appStore.getters['shared/isLoggedIn'] === false) &&
    to.name == "search" &&
    from.name == "home"
  ) {
    console.log("sending you home");
    // redirect the user to the login page
    next("/");
  } else next();
});

export default router;
